export const PRODUCTION_SERVER = 'https://meet.sombrerito.co';
export const SERVER_URL =
  process.env.NODE_ENV === 'development'
    ? process.env.EXPO_SERVER || PRODUCTION_SERVER
    : PRODUCTION_SERVER;
